import * as React from 'react';
import { useSelector } from 'react-redux';
import { getFilters, getNewBuildings, getNewbuildingsCounts } from '../../selectors';
import { ProjectsList as ProjectsListComponent } from '../../components/ProjectsListRedesigned';
import { NewBuildingCard } from '../NewBuildingCardRedesigned';
import { TViewMode } from '../Projects/types';
import { getNewBuildingsForRender } from './helpers';
import { EmptyNewbuildingsBanner } from '../../components/EmptyNewbuildingsBanner';
import { ProjectsListButton } from '../../components/ProjectsListButton';

interface IProjectsListProps {
  mode: TViewMode;
}

export function ProjectsListRedesigned({ mode }: IProjectsListProps) {
  const {
    data: { list },
  } = useSelector(getNewBuildings);
  const filters = useSelector(getFilters);
  const counts = useSelector(getNewbuildingsCounts);

  const count = React.useMemo(() => {
    const listingType = filters.newbuildingStatus;

    const tab = counts.find(tab => tab.newbuildingStatus === listingType);

    return tab?.count;
  }, [filters, counts]);

  const listingUrl = React.useMemo(() => {
    const listingType = filters.newbuildingStatus;

    const tab = counts.find(tab => tab.newbuildingStatus === listingType);

    return tab?.listingUrl;
  }, [filters, counts]);

  const { newBuildingsForRender } = getNewBuildingsForRender({ newBuildings: list, show: false, mode });
  const projects = React.useMemo(() => {
    return newBuildingsForRender.map((item, index) => (
      <NewBuildingCard
        key={item.id}
        newbuildingId={item.id}
        viewMode={mode}
        index={index}
        singleCard={newBuildingsForRender.length === 1}
      />
    ));
  }, [mode, newBuildingsForRender]);

  if (!newBuildingsForRender.length) {
    return <EmptyNewbuildingsBanner />;
  }

  return (
    <ProjectsListComponent
      list={projects}
      mode={mode}
      showMoreButton={count && listingUrl ? <ProjectsListButton url={listingUrl} count={count} /> : null}
    />
  );
}
